export const EVENT_LOADING = 'loading';
